export const courtTypes = [
  {
    value: 'Court of Appeals - CDO',
    label: 'Court of Appeals - CDO',
  },
  {
    value: 'Court of Appeals - Manila',
    label: 'Court of Appeals - Manila',
  },
  {
    value: 'Court of Appeals - Cebu',
    label: 'Court of Appeals - Cebu',
  },
  {
    value: 'Court of Tax Appeals',
    label: 'Court of Tax Appeals',
  },
  {
    value: 'Sandiganbayan',
    label: 'Sandiganbayan',
  },
  {
    value: 'Office of the Court Administrator',
    label: 'Office of the Court Administrator',
  },
  {
    value:
      'Mandatory Continuing Legal Education Office',
    label:
      'Mandatory Continuing Legal Education Office',
  },
  {
    value: 'Supreme Court (FMBO)',
    label: 'Supreme Court (FMBO)',
  },
  {
    value: 'Regional Trial Court',
    label: 'Regional Trial Court',
  },
  {
    value: 'Sharia District Court',
    label: 'Sharia District Court',
  },
  {
    value: 'Municipal Trial Court',
    label: 'Municipal Trial Court',
  },
  {
    value: 'Municipal Trial Court in Cities',
    label: 'Municipal Trial Court in Cities',
  },
  {
    value: 'Municipal Circuit Trial Court',
    label: 'Municipal Circuit Trial Court',
  },
  {
    value: 'Sharia Circuit Court',
    label: 'Sharia Circuit Court',
  },
  {
    value: 'Metropolitan Trial Court',
    label: 'Metropolitan Trial Court',
  },
]
